
import {
  error as showNotificationError
} from 'zoomforth_app_basics/action_creators/notifications.js';

import { getDefaultErrorStringForXhr, getXhrStatusCode } from './error_messaging.js';


const getErrorMessageFromServer = (xhr)=> {
  const statusCode = getXhrStatusCode(xhr);
  if (statusCode >= 400 && statusCode <= 499) {
    try {
      return JSON.parse(xhr.responseText).error.message;
    } catch (e) {
      return null;
    }
  }
  return null;
};


export const showNotificationErrorForXhr = (xhr)=> {
  let errorMessage = getErrorMessageFromServer(xhr);
  if (!errorMessage) {
    errorMessage = getDefaultErrorStringForXhr(xhr);
  }
  return showNotificationError({
    children: errorMessage
  });
};